import BpkSectionHeader from '@skyscanner/backpack-web/bpk-component-section-header';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import RichText from '../RichText';

import type { Document } from '@contentful/rich-text-types';
import type { ContentBlurb as ContentBlurbData } from '@shared/types/details-page-props';

import STYLES from './ContentBlurb.module.scss';

const cls = cssModules(STYLES);

type Props = {
  contentBlurb: ContentBlurbData;
  componentName?: string;
};

const ContentBlurb = ({ componentName, contentBlurb }: Props) => {
  const { content, subtitle, title } = contentBlurb;
  const uniqueId = componentName ?? '';

  // Split content into richText Documents
  const contentArray = Array.isArray(content) ? content : [];
  const richTextDocs = contentArray.filter(
    (item): item is Document => typeof item === 'object' && 'nodeType' in item,
  );

  // Check if we have any content to display
  const hasRichText = richTextDocs.length > 0;

  if (!hasRichText) {
    return null;
  }

  return (
    <div className={cls('ContentBlurb')}>
      {!!title && (
        <div className={cls('ContentBlurb__header')}>
          <BpkSectionHeader title={title} description={subtitle} />
        </div>
      )}
      <div id={uniqueId} className={cls('ContentBlurb__content')}>
        {/* Render RichText Documents */}
        {richTextDocs.map((doc, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <RichText key={`richtext-${index}`} body={doc} />
        ))}
      </div>
    </div>
  );
};

export default ContentBlurb;
